/**
 * Navbar Orchestrator
 * Manages navigation functions in parallel
 *
 * Uses static imports and passes config down to functions
 */
import { init as dropdownInit } from './functions/dropdown.ts';
import { init as menuInit } from './functions/menu.ts';
import { init as arrowNavigationInit } from './functions/arrow-navigation.ts';

export async function init(navbarConfig) {
  const cleanup = { destroyFunctions: [] };

  // Load all functions in parallel - use allSettled for resilient loading
  const results = await Promise.allSettled([
    dropdownInit(navbarConfig.dropdown),
    menuInit(navbarConfig.menu, navbarConfig),
    arrowNavigationInit(navbarConfig['arrow-navigation'], navbarConfig),
  ]);

  // Collect destroy functions from successful inits
  results.forEach((result) => {
    if (result.status === 'fulfilled' && result.value?.destroy) {
      cleanup.destroyFunctions.push(result.value.destroy);
    }
  });

  // Log summary
  const succeeded = results.filter((r) => r.status === 'fulfilled').length;
  const failed = results.length - succeeded;
  if (failed > 0) {
    console.warn(
      `[navbar] ${succeeded}/${results.length} functions loaded successfully. ${failed} failed but won't affect other functions.`
    );
  }

  return {
    result: 'navbar initialized',
    destroy: () => {
      cleanup.destroyFunctions.forEach((destroyFn) => {
        try {
          destroyFn();
        } catch (error) {
          console.error('[navbar] Error during cleanup:', error);
        }
      });
      cleanup.destroyFunctions.length = 0;
    },
  };
}
